export const eventStrategy = {
  selectMesaType: {
    selectTypeEvent: {
      Wedding: {
        URL: '/createEvent/selectMesaType',
        validationFunction: 'validateSelectMesaType',
        steps: [
          {
            Wedding: {
              URL: '/createEvent/Wedding/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
          {
            createEvent: {
              URL: '/createEvent/Wedding/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
          {
            Address: {
              URL: '/createEvent/Wedding/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
          {
            Contract: {
              URL: '/createEvent/Wedding/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
        ],
      },
      baby: {
        URL: '/createEvent/selectMesaType',
        validationFunction: 'validateSelectMesaType',
        steps: [
          {
            baby: {
              URL: '/createEvent/baby/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
          {
            createEvent: {
              URL: '/createEvent/baby/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
          {
            Address: {
              URL: '/createEvent/baby/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
          {
            Contract: {
              URL: '/createEvent/baby/selectMesaType',
              validationFunction: 'validateSelectMesaType',
            },
          },
        ],
      },
      Level: '1',
      URL: '/createEvent/selectMesaType',
      validationFunction: 'validateSelectMesaType',
    },
    selectTypeCelebration: {
      Level: '1',
      URL: '/createEvent/selectTypeCelebration',
      validationFunction: 'validateSelectTypeCelebration',
    },
    Level: '1',
    URL: '/createEvent/selectMesaType',
    validationFunction: 'validateSelectMesaType',
  },
};

export const eventSteps = ['selectMesaType', 'selectTypeEvent', 'MainPage', 'CreateEvent', 'Address', 'Contract', 'templatePage'];
